exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d2-crud .d2-crud-header{border-bottom:1px dotted rgba(0,0,0,.2)}.d2-crud .d2-crud-body{padding:15px 0;overflow:hidden}.d2-crud .d2-crud-pagination{padding:15px 0}.d2-crud .form-item-helper{display:block;margin-top:5px;margin-bottom:5px;color:#737373;line-height:normal}.d2-crud .el-collapse-item__wrap{padding-top:7px}.d2-crud .el-collapse-item__content{padding-left:30px;padding-right:30px}", ""]);

// exports
